import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import { Row, Col } from 'react-bootstrap';
import Langs from "../../app/lang/langs";
import { useDispatch, useSelector } from "react-redux";
import { getAllCollabs, getPostes } from "../../components/collabs/collabsSlice";
import { getTeams } from "../../components/teams/teamsSlice";
import { InputField } from "../../components/inputs/InputField";
import { addOpportunity, editOpportunity, getOpportunities } from "../../components/clients/clientsSlice";
import { DynamicButton } from "../../components/buttons/DynamicButton";
import moment from "moment";
import { Tag } from "primereact/tag";
import { AssetsPannel } from "../../components/inputs/AssetsPannel";
import { checkPermission } from "../../app/utils/helpers";
import { config, isFeatureHidden } from "../../app/utils/config";
import SuggestedProfilesPanel from "./SuggestedProfilesPanel";


export default function OpportunityModal(props) {

    const dispatch = useDispatch()
    const mounted = useRef(false)

    const [selectedItem, setSelectedItem] = useState(null)
    const [visibleFields, setVisibleFields] = useState([])
    const [fieldErrors, setFieldErrors] = useState({})
    const fieldRefs = useRef({})

    const postes = useSelector((state) => state.collabs.postes)
    const teams = useSelector((state) => state.teams.allTeams)
    const allCollabs = useSelector((state) => state.collabs.allCollabsList)
    const userId = useSelector((state) => state.login.userId)

    useEffect(() => {
        if (!mounted.current) {
            mounted.current = true
        }
    })

    useEffect(() => {
        setVisibleFields([
            { key: "title", type: "text", mandatory: true },
            { key: "id_team", type: "dropdown", options: teams, optionLabel: "label", optionValue: "id", filter: true, InputFieldLabel: "TEAM", mandatory: true },
            { key: "category", type: "dropdown", options: categoryOptions, optionLabel: "label", optionValue: "value", itemTemplate: categoryBodyTemplate, valueTemplate: categoryBodyTemplate, mandatory: true },
            { key: "id_poste", type: "dropdown", options: postes, optionLabel: "name", optionValue: "id", filter: true, InputFieldLabel: "POSTE", mandatory: true },
            { key: "priority", type: "dropdown", options: priorityOptions, optionLabel: "label", optionValue: "value", itemTemplate: priorityBodyTemplate, valueTemplate: priorityBodyTemplate, mandatory: true },
            { key: "start_date", type: "date", mandatory: true },
            { key: "profiles_number", type: "number", min: 1, maxFractionDigits: 0, mandatory: true },
            { key: "provided_profiles_number", type: "number", min: 1, maxFractionDigits: 0, mandatory: true },
            { key: "status", type: "dropdown", options: statusOptions, optionLabel: "label", optionValue: "value", itemTemplate: statusBodyTemplate, valueTemplate: statusBodyTemplate, mandatory: true },
            { key: "sub_status", type: "dropdown", options: subStatusOptions, optionLabel: "label", optionValue: "value", itemTemplate: subStatusBodyTemplate, valueTemplate: subStatusBodyTemplate },
            { key: "localisation", type: "string" },
            { key: "description", type: "text", rows: 6, mandatory: true },
            { key: "competences", type: "text", rows: 6 },
            { key: "response_comments", type: "text", rows: 6 },
            { key: "helped_by", type: "dropdown", options: allCollabs, optionLabel: "label", optionValue: "id", filter: true },
            { key: "demanded_by", type: "dropdown", options: allCollabs, optionLabel: "label", optionValue: "id", filter: true },
            { key: "handled_by", type: "dropdown", options: allCollabs, optionLabel: "label", optionValue: "id", filter: true },
            { key: "prospect", type: "text", rows: 6 }
        ])
    }, [teams, postes, allCollabs])

    useEffect(() => {
        if (props.visible) {
            setFieldErrors({})
            dispatch(getPostes())
            dispatch(getTeams())
            dispatch(getAllCollabs())
            if (props.type == "EDIT") {
                setSelectedItem(props.onViewItem)
            } else {
                setSelectedItem({
                    "status": "Non démarré",
                    "profiles_number": 1,
                    "provided_profiles_number": 0,
                    "priority": "Faible",
                    "demanded_by": parseInt(userId)
                })
            }
        }
    }, [props.visible])

    const priorityOptions = [
        { label: 'Faible', value: 'Faible' },
        { label: 'Normale', value: 'Normale' },
        { label: 'Urgent', value: 'Urgent' }
    ]

    const statusOptions = [
        { label: 'Non démarré', value: 'Non démarré' },
        { label: 'En cours', value: 'En cours' },
        { label: 'Clos Gagné', value: 'Clos Gagné' },
        { label: 'Clos Abandonné', value: 'Clos Abandonné' },
        { label: 'Clos Perdu', value: 'Clos Perdu' },
        { label: 'Non pris en charge', value: 'Non pris en charge' },
    ]

    const categoryOptions = [
        { label: 'Demande de Profil', value: 'Demande de Profil' },
        { label: 'Besoin Profil Interne', value: 'Besoin Profil Interne' },
        { label: 'Projet Bureautique', value: 'Projet Bureautique' },
        { label: 'Projet Infra', value: 'Projet Infra' },
        { label: 'Infogérance', value: 'Infogérance' },
        { label: 'Autres', value: 'Autres' },
    ]

    const subStatusOptions = [
        { label: '-', value: '-' },
        { label: 'Recherche de profils', value: 'Recherche de profils' },
        { label: 'RDV candidats', value: 'RDV candidats' },
        { label: 'CV(s) transmis', value: 'CV(s) transmis' },
        { label: 'Relance', value: 'Relance' },
        { label: 'Attente retour client', value: 'Attente retour client' },
        { label: 'Attente retour Responsable de compte', value: 'Attente retour Responsable de compte' },
    ]

    const categoryBodyTemplate = (option) => {
        if (!option) return <Tag value="Unknown" severity="danger" />;
        switch (option?.value) {
            case "Demande de Profil":
                return <Tag value="Demande de Profil" severity="info" />;
            case "Besoin Profil Interne":
                return <Tag value="Besoin Profil Interne" severity="primary" />;
            case "Projet Bureautique":
                return <Tag value="Projet Bureautique" severity="success" />;
            case "Projet Infra":
                return <Tag value="Projet Infra" severity="warning" />;
            case "Infogérance":
                return <Tag value="Infogérance" severity="secondary" />;
            case "Autres":
                return <Tag value="Autres" severity="danger" />;
            default:
                return <Tag value="Unknown" severity="danger" />;
        }
    }

    const statusBodyTemplate = (option) => {
        if (!option) return <Tag value="Inconnu" severity="danger" />;
        switch (option?.value) {
            case "Non démarré":
                return <Tag value="Non démarré" severity="secondary" />;
            case "En cours":
                return <Tag value="En cours" severity="info" />;
            case "Clos Gagné":
                return <Tag value="Clos Gagné" severity="success" />;
            case "Clos Abandonné":
                return <Tag value="Clos Abandonné" severity="warning" />;
            case "Clos Perdu":
                return <Tag value="Clos Perdu" severity="danger" />;
            case "Non pris en charge":
                return <Tag value="Non pris en charge" severity="danger" />;
            default:
                return <Tag value="Inconnu" severity="danger" />;
        }
    }

    const subStatusBodyTemplate = (option) => {
        if (!option) return <Tag value="Inconnu" severity="danger" />;
        switch (option?.value) {
            case "-":
                return <Tag value="-" severity="secondary" />;
            case "Recherche de profils":
                return <Tag value="Recherche de profils" severity="info" />;
            case "RDV candidats":
                return <Tag value="RDV candidats" severity="primary" />;
            case "CV(s) transmis":
                return <Tag value="CV(s) transmis" severity="success" />;
            case "Relance":
                return <Tag value="Relance" severity="warning" />;
            case "Attente retour client":
                return <Tag value="Attente retour client" severity="warning" />;
            case "Attente retour Responsable de compte":
                return <Tag value="Attente retour Responsable de compte" severity="warning" />;
            default:
                return <Tag value="Inconnu" severity="danger" />;
        }
    }

    const priorityBodyTemplate = (option) => {
        if (!option) return <Tag value="Inconnu" severity="danger" />;
        return <div style={{ color: (["Normale"].includes(option.value) ? "green" : (["Urgent"].includes(option.value) ? "red" : "")) }}>
            <strong>{option.value}</strong>
        </div>
    }

    const handleSave = (opp) => {
        const errors = {}
        visibleFields.forEach(field => {
            if (field.mandatory) {
                const val = opp?.[field.key]
                if (val === null || val === undefined || val === '') {
                    errors[field.key] = true
                }
            }
        })

        if (Object.keys(errors).length > 0) {
            setFieldErrors(errors)
            const firstErrorKey = visibleFields.find(f => errors[f.key])?.key
            if (firstErrorKey && fieldRefs.current[firstErrorKey]) {
                fieldRefs.current[firstErrorKey].scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
            return
        }

        setFieldErrors({})
        let sd = opp.start_date ? moment(opp.start_date).format("YYYY-MM-DD 00:00:00") : null
        opp = {
            ...opp, 
            start_date: sd
        }
        if (props.type == "EDIT") {
            dispatch(editOpportunity({ opportunity: opp }))
                .then(((actionResponse) => {
                    if (editOpportunity.fulfilled.match(actionResponse)) {
                        if (actionResponse.payload.responseData && actionResponse.payload.responseData.status) {
                            dispatch(getOpportunities())
                            handleClose();
                        }
                    }
                }))
        } else {
            dispatch(addOpportunity({ opportunity: opp }))
                .then(((actionResponse) => {
                    if (addOpportunity.fulfilled.match(actionResponse)) {
                        if (actionResponse.payload.responseData && actionResponse.payload.responseData.status) {
                            dispatch(getOpportunities())
                            handleClose()
                        }
                    }
                }))
        }
    }

    const handleClose = () => {
        props.setVisible(false)
        setSelectedItem(null)
    }

    const footer = () => {
        return <Row className="d-flex justify-content-center" >
            <Col lg={2} xs={2}>
                <DynamicButton
                    onClick={() => handleSave(selectedItem)}
                    className='me-auto'
                    title={props.type == "EDIT" ? <Langs str="SAVE" /> : <Langs str="ADD" />}
                    active={true}
                    color="green"
                />
            </Col>
        </Row>
    }
    return (
        <Dialog
            visible={props.visible}
            onHide={() => { if (!props.visible) return; handleClose() }}
            position="center"
            draggable={false}
            dismissableMask={true}
            style={{ width: '55rem', height: "70vh", maxHeight: "100%", marginRight: 0 }}
            footer={footer}
            header={props.type == "EDIT" ? <Langs str="OPPORTUNITY_DETAILS" /> : <Langs str="ADD_OPPORTUNITY" />}
        >
            {visibleFields.map(field => selectedItem &&
                <div key={field.key} ref={el => fieldRefs.current[field.key] = el}>
                    <InputField
                        field={field}
                        onChange={(e) => {
                            setSelectedItem(prev => ({ ...prev, [field.key]: e }))
                            if (fieldErrors[field.key]) {
                                setFieldErrors(prev => ({ ...prev, [field.key]: false }))
                            }
                        }}
                        value={selectedItem && selectedItem[field.key]}
                        error={fieldErrors[field.key]}
                    />
                </div>
            )}
            {/*
              * Candidates we already know for this poste, from V-Reference. Shown while the
              * opportunity is being written — including on ADD, where there is no saved row
              * yet — because that is when knowing "we already have three Java devs on file"
              * actually changes what you do.
              *
              * `opportunities:edit` only: this surfaces contacts referred by other people, so
              * it is not for someone who can merely view opportunities. The server enforces
              * the same rule; this check just avoids rendering a panel that would 403.
              *
              * Gone entirely while 'vreference' is in HIDDEN_FEATURES: the box is a window
              * onto the referral directory, so it cannot stay once the directory itself is
              * hidden — it would be the one place V-Reference data still showed.
              */}
            {!isFeatureHidden('vreference') &&
                checkPermission(config.scopes.opportunities, config.permissionTypes.edit) &&
                <SuggestedProfilesPanel
                    idPoste={selectedItem?.id_poste}
                    competences={selectedItem?.competences}
                />}

            {props.type == "EDIT" && <AssetsPannel
                tableName='opportunities'
                idParent={selectedItem?.id}
                assets={selectedItem?.assets}
                uploadCallBackFunction={() => { }}
                deleteCallBackFunction={() => { }}
                label="Assets"
                parentSetter={setSelectedItem}
            />}
        </Dialog>
    )
}